import styled from "styled-components";

const WorkSegment = styled.section`
  margin: 0 0 128px 0;
`;

export { WorkSegment };
